import lazyLoadable from "@/utils/LazyLoadable";
import Loader from "./components/Global/Loader";

const CenterLoading = () => {
  return (
    <div className="flex justify-center items-center h-[100dvh] w-[100dvw]">
      <Loader />
    </div>
  );
};

export const Login = lazyLoadable(() => import("@/pages/Auth/Login"), {
  fallback: <CenterLoading />,
});

export const Signup = lazyLoadable(() => import("@/pages/Auth/Signup"), {
  fallback: <CenterLoading />,
});

export const ProjectTasksList = lazyLoadable(
  () => import("@/pages/Project/ProjectTasksList"),
  {
    fallback: <CenterLoading />,
  }
);

export const CreateTask = lazyLoadable(
  () => import("@/pages/Project/CreateTask"),
  {
    fallback: <CenterLoading />,
  }
);

export const Timesheet = lazyLoadable(() => import("@/pages/Timesheet"), {
  fallback: <CenterLoading />,
});

export const Approval = lazyLoadable(() => import("@/pages/Approval"), {
  fallback: <CenterLoading />,
});

export const TimesheetApproval = lazyLoadable(
  () => import("@/pages/Timesheet/TimesheetApproval"),
  {
    fallback: <CenterLoading />,
  }
);

export const Onboarding = lazyLoadable(
  () => import("@/components/Onboarding"),
  {
    fallback: <CenterLoading />,
  }
);

export const VerifyEmail = lazyLoadable(() => import("@/pages/VerifyEmail"), {
  fallback: <CenterLoading />,
});

export const InviteLink = lazyLoadable(() => import("@/pages/Invite"), {
  fallback: <CenterLoading />,
});

export const CompanyProfile = lazyLoadable(
  () => import("@/pages/AccountSettings/CompanyProfile"),
  {
    fallback: <CenterLoading />,
  }
);

export const Integration = lazyLoadable(() => import("@/pages/Integration"), {
  fallback: <CenterLoading />,
});

export const PlansBilling = lazyLoadable(() => import("@/pages/PlansBilling"), {
  fallback: <CenterLoading />,
});

export const QuickbooksCallback = lazyLoadable(
  () => import("@/pages/Quickbooks/QuickbooksCallback"),
  {
    fallback: <CenterLoading />,
  }
);

export const Gantt = lazyLoadable(() => import("@/pages/Gantt"), {
  fallback: <CenterLoading />,
});

export const Retainer = lazyLoadable(
  () => import("@/pages/CreditsRetainers/Retainer"),
  {
    fallback: <CenterLoading />,
  }
);

export const PreviewRetainer = lazyLoadable(
  () => import("@/pages/CreditsRetainers/PreviewRetainer"),
  {
    fallback: <CenterLoading />,
  }
);

export const CreditMemo = lazyLoadable(
  () => import("@/pages/CreditsRetainers/CreditMemo"),
  {
    fallback: <CenterLoading />,
  }
);

export const PreviewCreditMemo = lazyLoadable(
  () => import("@/pages/CreditsRetainers/PreviewCreditMemo"),
  {
    fallback: <CenterLoading />,
  }
);
export const Procurement = lazyLoadable(() => import("@/pages/Procurement"), {
  fallback: <CenterLoading />,
});

export const ProjectPurchaseOrders = lazyLoadable(
  () => import("@/pages/Project/ProjectPurchaseOrders"),
  {
    fallback: <CenterLoading />,
  }
);

export const PreviewInvoice = lazyLoadable(
  () => import("@/pages/Project/PreviewInvoice"),
  {
    fallback: <CenterLoading />,
  }
);

export const CreateProject = lazyLoadable(
  () => import("@/pages/Project/CreateProject"),
  {
    fallback: <CenterLoading />,
  }
);

export const CreateProduct = lazyLoadable(
  () => import("@/pages/Product/CreateProduct"),
  {
    fallback: <CenterLoading />,
  }
);

export const ListSpecifications = lazyLoadable(
  () => import("@/pages/DesignLibrary/ListSpecifications"),
  {
    fallback: <CenterLoading />,
  }
);

export const ProjectFiles = lazyLoadable(
  () => import("@/pages/projectFiles/page"),
  {
    fallback: <CenterLoading />,
  }
);

export const Projects = lazyLoadable(() => import("@/pages/Projects"), {
  fallback: <CenterLoading />,
});

export const CreateService = lazyLoadable(
  () => import("@/pages/Service/CreateService"),
  {
    fallback: <CenterLoading />,
  }
);

export const CreateVendor = lazyLoadable(
  () => import("@/pages/Vendor/CreateVendor"),
  {
    fallback: <CenterLoading />,
  }
);

export const ProjectSpecificationList = lazyLoadable(
  () => import("@/pages/Project/ProjectSpecificationList"),
  {
    fallback: <CenterLoading />,
  }
);

export const ProjectLocationList = lazyLoadable(
  () => import("@/pages/Project/ProjectLocationList"),
  {
    fallback: <CenterLoading />,
  }
);

export const CreateClient = lazyLoadable(
  () => import("@/pages/Client/CreateClient"),
  {
    fallback: <CenterLoading />,
  }
);

export const ProjectProposalList = lazyLoadable(
  () => import("@/pages/Project/ProjectProposalList"),
  {
    fallback: <CenterLoading />,
  }
);

export const ProposalSpecificationList = lazyLoadable(
  () => import("@/pages/Project/ProposalSpecificationList"),
  {
    fallback: <CenterLoading />,
  }
);

export const CreateProjectProposal = lazyLoadable(
  () => import("@/pages/Project/CreateProjectProposal"),
  {
    fallback: <CenterLoading />,
  }
);

export const Members = lazyLoadable(() => import("@/pages/Member"), {
  fallback: <CenterLoading />,
});
export const Clients = lazyLoadable(() => import("@/pages/Client"), {
  fallback: <CenterLoading />,
});
export const Vendors = lazyLoadable(() => import("@/pages/Vendor"), {
  fallback: <CenterLoading />,
});
export const CreateMember = lazyLoadable(
  () => import("@/pages/Member/CreateMember"),
  {
    fallback: <CenterLoading />,
  }
);
export const AccountSettings = lazyLoadable(
  () => import("@/pages/AccountSettings/AccountSettings"),
  {
    fallback: <CenterLoading />,
  }
);

export const SalesTax = lazyLoadable(
  () => import("@/pages/SalesTax/ListSalesTax"),
  {
    fallback: <CenterLoading />,
  }
);

export const SalesCategory = lazyLoadable(
  () => import("@/pages/SaleCategory/ListSaleCategory"),
  {
    fallback: <CenterLoading />,
  }
);

export const CreditRetainers = lazyLoadable(
  () => import("@/pages/CreditsRetainers"),
  {
    fallback: <CenterLoading />,
  }
);

export const ProjectInvoiceList = lazyLoadable(
  () => import("@/pages/Project/ProjectInvoiceList"),
  {
    fallback: <CenterLoading />,
  }
);

export const SettingSidebar = lazyLoadable(
  () => import("@/components/Global/SettingSidebar"),
  {
    fallback: <CenterLoading />,
  }
);

export const ForgotPassword = lazyLoadable(
  () => import("@/components/Auth/ForgotPassword"),
  {
    fallback: <CenterLoading />,
  }
);

export const PasswordUpdated = lazyLoadable(
  () =>
    import("@/components/Auth/ForgotPassword").then((module) => ({
      default: module.PasswordUpdated,
    })),
  {
    fallback: <CenterLoading />,
  }
);

export const ResetPassword = lazyLoadable(
  () =>
    import("@/components/Auth/ForgotPassword").then((module) => ({
      default: module.ResetPassword,
    })),
  {
    fallback: <CenterLoading />,
  }
);
